{
  "PHONE_CTRLS": {
    "EXTENSION_BANNER": {
      "TEXT": "L'extension Chrome n'est pas installée.",
      "CTA": "Installer l'extension"
    },
    "STATUS": {
      "OFFLINE": "Téléphone hors ligne",
      "IN_OTHER_TAB": "Téléphone connecté dans un autre onglet",
      "CONNECTING": "Connexion en cours...",
      "DISCONNECTING": "Déconnexion en cours...",
      "ONLINE": "Téléphone en ligne",
      "DIALING": "Numérotation",
      "TRANSFERRING": "Transfert en cours...",
      "CONSULTING": "En ligne avec l'agent",
      "CALLER_ON_HOLD": "L'appelant est en attente",
      "BUSY": "Occupé",
      "DND": "DND",
      "UNAVAILABLE": "Indisponible",
      "REJECTED": "Appel rejeté",
      "CALL_FAILED": "Échec de l'appel"
    },
    "QUEUES": {
      "MORE": "Autres files d'attente"
    },
    "TABS": {
      "PHONE": "Téléphone",
      "SMS": "SMS",
      "HISTORY": "Historique"
    },
    "HISTORY": {
      "OPEN": "Ouvert",
      "RECENT": "Récents",
      "MISSED": "Manqués",
      "LOADING": "Chargement des appels...",
      "EMPTY": "Aucun appel ici",
      "ERROR": "Impossible de charger les appels",
      "CALL": "Rappeler",
      "CALL_STATUS": {
        "BUTTON": "Définir le statut d'appel",
        "TITLE": "Statut d'appel",
        "SEARCH_PLACEHOLDER": "Rechercher des statuts...",
        "LOADING": "Chargement des statuts...",
        "NO_OPTIONS": "Aucun statut d'appel n'est configuré",
        "NO_MATCH": "Aucun statut ne correspond",
        "OPTIONS_ERROR": "Impossible de charger les statuts",
        "RETRY": "Réessayer",
        "CONFIRM_QUESTION": "Définir le statut « {status} » et résoudre la conversation ?",
        "CONFIRM": "Confirmer",
        "BACK": "Précédent",
        "CANCEL": "Annuler",
        "SAVING": "Enregistrement en cours...",
        "SAVE_ERROR": "Impossible d'enregistrer le statut",
        "RESOLVE_ERROR": "Statut enregistré, mais impossible de résoudre la conversation"
      }
    },
    "SMS": {
      "NUMBER_PLACEHOLDER": "Numéro de téléphone, ex. +421903000000",
      "BODY_PLACEHOLDER": "Saisissez votre message...",
      "SEGMENTS": "({segments} SMS)",
      "SEND": "Envoyer un SMS",
      "SENDING": "Envoi en cours...",
      "SENT": "SMS envoyé",
      "LOADING": "Chargement des boîtes de réception SMS...",
      "NO_INBOX": "Ce compte n'a pas de boîte de réception SMS, le SMS ne peut donc pas être envoyé.",
      "INVALID_NUMBER": "Saisissez le numéro au format international, avec le + initial.",
      "ERROR": "Le SMS n'a pas pu être envoyé. Veuillez réessayer."
    },
    "ACTIONS": {
      "CONNECT": "Se connecter",
      "GO_TO_TAB": "Aller à cet onglet",
      "DISCONNECT": "Se déconnecter",
      "ANSWER": "Répondre",
      "HANGUP": "Raccrocher",
      "HOLD": "Mettre en attente",
      "MUTE": "Couper le microphone",
      "SILENCE": "Couper le son",
      "TRANSFER": "Transférer",
      "COMPLETE_TRANSFER": "Finaliser le transfert",
      "RETURN_TO_CALLER": "Revenir à l'appelant",
      "CANCEL_TRANSFER": "Annuler le transfert",
      "DIALPAD": "Afficher le clavier",
      "OPEN_CONVERSATION": "Ouvrir la conversation"
    },
    "NOTIFICATIONS": {
      "INCOMING_CALL": "Appel entrant",
      "INCOMING_CALL_FROM": "Appel entrant de {name} ({number})",
      "INCOMING_CALL_FROM_NUMBER": "Appel entrant de {number}",
      "ANSWER": "Répondre",
      "DECLINE": "Refuser"
    },
    "TRANSFER": {
      "TITLE": "Transférer l'appel",
      "PLACEHOLDER": "Entrez le numéro de destination du transfert...",
      "SEARCH_PLACEHOLDER": "Rechercher des agents...",
      "TARGET_PLACEHOLDER": "Destination du transfert sélectionnée",
      "CONFIRM": "Transférer",
      "MODE_DIRECT": "Transférer maintenant",
      "MODE_CONSULT": "Appeler d'abord l'agent",
      "CANCEL": "Annuler"
    },
    "QUEUE_BREAK": {
      "CONFIRM_BREAK": "Êtes-vous sûr de vouloir prendre une pause pour toutes les files d'attente ?",
      "CONFIRM_READY": "Êtes-vous sûr de vouloir revenir au statut « prêt » pour toutes les files d'attente ?",
      "CONFIRM_BREAK_QUEUE": "Êtes-vous sûr de vouloir vous déconnecter de la file d'attente {queue} ?",
      "CONFIRM_READY_QUEUE": "Êtes-vous sûr de vouloir vous connecter à la file d'attente {queue} ?",
      "LOGIN_TO_QUEUE": "Se connecter",
      "LOGOUT_FROM_QUEUE": "Se déconnecter",
      "LOGIN_TO_ALL_QUEUES": "Se connecter à toutes les files d'attente",
      "LOGOUT_FROM_ALL_QUEUES": "Se déconnecter de toutes les files d'attente",
      "OPTION_LOGOUT": "Se déconnecter",
      "OPTION_BREAK": "Pause",
      "OPTION_LUNCH": "Déjeuner",
      "OPTION_AWAY": "Absent",
      "OPTION_DO_NOT_DISTURB": "Ne pas déranger",
      "OPTION_BUSINESS_TRIP": "Déplacement professionnel",
      "CONFIRM": "Confirmer",
      "CANCEL": "Annuler"
    },
    "CONNECTION_ERROR": {
      "TITLE": "Aucune connexion au système téléphonique",
      "MESSAGE": "Votre connexion Internet semble ne pas fonctionner. Veuillez la vérifier et réessayer.",
      "CREDENTIALS_TITLE": "Le système téléphonique a rejeté vos identifiants",
      "CREDENTIALS_MESSAGE": "Le système téléphonique a refusé le nom d'utilisateur ou le mot de passe enregistré dans votre profil. Vérifiez-les dans les Paramètres de profil, ou contactez votre administrateur.",
      "CONFIGURATION_TITLE": "Les paramètres téléphone ne sont pas valides",
      "CONFIGURATION_MESSAGE": "Le nom d'utilisateur SIP ou l'adresse du serveur n'est pas dans un format valide, le téléphone ne peut donc pas se connecter. Corrigez-le dans les Paramètres de profil.",
      "NETWORK_SHORT": "Échec de la connexion",
      "CREDENTIALS_SHORT": "Identifiants rejetés",
      "CONFIGURATION_SHORT": "Paramètres téléphone non valides",
      "RETRY": "Réessayer",
      "DISMISS": "Annuler"
    },
    "CONNECTION_QUALITY": "Qualité de la connexion",
    "CONNECTION_QUALITY_EXCELLENT": "Excellente",
    "CONNECTION_QUALITY_GOOD": "Bonne",
    "CONNECTION_QUALITY_FAIR": "Moyenne",
    "CONNECTION_QUALITY_POOR": "Mauvaise",
    "CONNECTION_QUALITY_DISCONNECTED": "Déconnecté"
  },
  "DIAL_REDIRECT": {
    "DIALING": "Numérotation de {number}… Vous pouvez fermer cet onglet.",
    "NO_NUMBER": "Aucun numéro fourni. Utilisez ?number=+420..."
  },
  "PHONE_DIAL": {
    "PLACEHOLDER": "Entrez le numéro de téléphone...",
    "ACTIONS": {
      "DIAL": "Composer le numéro",
      "DIAL_FROM": "Choisir le numéro depuis lequel appeler"
    },
    "DIAL_FROM": {
      "TITLE": "Appeler depuis le numéro d'une boîte de réception"
    },
    "VALIDATION": {
      "REQUIRED": "Le numéro de téléphone est requis",
      "INVALID_FORMAT": "Format de numéro de téléphone invalide"
    }
  },
  "PHONE_AUDIO": {
    "TITLE": "Paramètres et test audio",
    "SELECT_DEVICE": "Sélectionner un appareil...",
    "SYSTEM_DEFAULT": "Par défaut du système",
    "SAVED": "Enregistré",
    "DISCONNECTED_SUFFIX": "non connecté",
    "DEVICE_DISCONNECTED": "L'appareil sélectionné n'est pas connecté. Les appels utilisent l'appareil par défaut du système jusqu'à son retour.",
    "MICROPHONE": {
      "TITLE": "Microphone",
      "START_TEST": "Tester le microphone",
      "STOP_TEST": "Arrêter le test",
      "LEVEL": "Niveau :",
      "VERDICT": {
        "LISTENING": "Dites quelque chose dans le micro…",
        "SILENT": "On ne vous entend pas. Vérifiez que le micro est allumé et que le bon est sélectionné.",
        "LOW": "On vous entend à peine. Choisissez un autre micro ou réglez le volume d'entrée dans les paramètres du système.",
        "GOOD": "Bon son — on vous entend bien."
      }
    },
    "SPEAKER": {
      "TITLE": "Haut-parleur",
      "TEST": "Tester le haut-parleur",
      "TESTING": "Test en cours...",
      "VOLUME": "Volume :",
      "USING_DEFAULT": "La sortie sélectionnée est indisponible — lecture sur la sortie par défaut du système."
    },
    "DONE": "Terminé",
    "ERRORS": {
      "MICROPHONE_ACCESS": "Erreur d'accès au microphone. Veuillez vérifier les autorisations.",
      "MICROPHONE_PERMISSION_DENIED": "L'accès au microphone est bloqué. Autorisez-le dans les paramètres du site de votre navigateur pour utiliser le téléphone.",
      "MICROPHONE_SILENT": "Votre microphone ne capte aucun son. Vérifiez vos paramètres audio.",
      "EXTENSION_REQUIRED": "Extension téléphonique non détectée. Veuillez l'installer ou l'activer pour utiliser le microphone.",
      "SPEAKER_TEST": "Erreur lors du test de la sortie du haut-parleur."
    }
  },
  "PHONE_STATUS": {
    "OFFLINE": "Hors ligne",
    "ONLINE": "En ligne",
    "BUSY": "Occupé"
  },
  "QUEUE_STATUS": {
    "READY": "Prêt",
    "NOT_READY": "N'accepte pas d'appels",
    "WRAP_UP": "Finalisation",
    "BREAK": "Pause",
    "LUNCH": "Déjeuner",
    "AWAY": "Absent",
    "DO_NOT_DISTURB": "Ne pas déranger",
    "BUSINESS_TRIP": "Déplacement professionnel",
    "OTHER_CALL": "Autre appel",
    "QUEUE_CALL": "Appel de file d'attente",
    "OFFLINE": "Hors ligne",
    "ONLINE": "En ligne",
    "NO_ACCESS": "Pas de téléphone",
    "PARTIALLY_READY": "Partiellement prêt",
    "MIXED": "Mixte",
    "CHAT_ONLINE": "En ligne (chat)",
    "CHAT_BUSY": "Occupé (chat)",
    "CHAT_OFFLINE": "Hors ligne (chat)"
  }
}
